import { createContext, ReactNode, useContext } from "react";

import { CALENDAR_START_DATE_DEFAULT } from "@/constants";

import { CalendarSettings } from "./types";

const DEFAULTS: CalendarSettings = {
  max: new Date(),
  min: new Date(CALENDAR_START_DATE_DEFAULT),
  locale: undefined,
  weekStartsOn: 1,
};

const CalendarContext = createContext<CalendarSettings>(DEFAULTS);

export const useCalendar = () => useContext(CalendarContext);

export const CalendarContextProvider: React.FC<{
  children?: ReactNode;
  value: Partial<CalendarSettings>;
}> = ({ value, children }) => (
  <CalendarContext.Provider value={{ ...DEFAULTS, ...value }}>
    {children}
  </CalendarContext.Provider>
);

export default CalendarContext;
